export enum Platform {
  Acast = 'Acast',
  YouTube = 'YouTube',
  TikTok = 'TikTok',
  Instagram = 'Instagram',
}

export const socialPlatforms: readonly Platform[] = [
  Platform.YouTube,
  Platform.Instagram,
  Platform.TikTok,
];

export const isSocialPlatform = (platform: string | null | undefined): platform is Platform =>
  socialPlatforms.includes(platform as Platform);
